import { apiClient } from './client';

export interface UserTenant {
  tenantId: string;
  name: string;
  code: string | null;
  logoUrl: string | null;
}

/**
 * GET /api/:tenantId/users/me/tenants
 * Retorna lista de tenants que el usuario puede acceder.
 * - SUPER_ADMIN ve todos los tenants
 * - ADMIN ve solo los asignados en allowedTenants
 */
export const getUserTenants = async (): Promise<{ tenants: UserTenant[] }> =>
  // Sin tenantId explícito: el interceptor de client.ts inyecta el de la sesión. Pasar el
  // del path de la URL (puede ser el código "demo" y no el UUID de la sesión) producía
  // /api/<uuid>/<codigo>/users/me/tenants → 404. El backend ignora el segmento y usa el JWT.
  (await apiClient.get('/api/users/me/tenants')).data;
